let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1B4Kc")).then(() => parcelRequire('lHZIj'));